import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Shield } from 'lucide-react';

// Admin only route protection
export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-800" />
      </div>
    );
  }
  
  if (user?.role !== 'ADMIN') {
    return (
      <div className="flex flex-col items-center justify-center h-96">
        <Shield className="w-16 h-16 text-red-400 mb-4" />
        <h2 className="text-xl font-bold text-slate-800 mb-2">Unauthorized Access</h2>
        <p className="text-slate-600 mb-4">This page is only accessible to administrators.</p>
        <Navigate to="/dashboard" replace />
      </div>
    );
  }
  
  return children;
};

// Manager or Admin route protection
export const ManagerRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-800" />
      </div>
    );
  }
  
  if (user?.role !== 'ADMIN' && user?.role !== 'MANAGER') {
    return (
      <div className="flex flex-col items-center justify-center h-96">
        <Shield className="w-16 h-16 text-red-400 mb-4" />
        <h2 className="text-xl font-bold text-slate-800 mb-2">Unauthorized Access</h2>
        <p className="text-slate-600 mb-4">This page requires manager or admin privileges.</p>
        <Navigate to="/dashboard" replace />
      </div>
    );
  }
  
  return children;
};

export default AdminRoute;
